import { getData } from './api-base.service';

export const getCaptureImageList = (studentId, courseactivationId) => {
  let data = { studentId: studentId, courseactivationId: courseactivationId };
  return getData('/CaptureImage/GetCaptureImages', data);
};



// WEBPACK FOOTER //
// ./src/service/captureImage.service.js